export default __webpack_public_path__ + "static/community_1-640d4f9e2ce8dbc383c0f0f11f66f375.jpg";